import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useLectureGroup = (cid:number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [groupList, setGroupList] = useState<LectureGroupListDto[] | any[]>();
    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.refcode.lecture.group.list, cid],
    () =>
      fetcher.refcode.getLectureGroupList({cid:cid}),
    {
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            setGroupList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  ); 

  const { mutate: groupInsert } = useMutation(
    [endpoints.refcode.lecture.group.add],
    fetcher.refcode.postLectureGroupInsert,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: groupUpdate } = useMutation(
    [endpoints.refcode.lecture.group.update],
    fetcher.refcode.postLectureGroupUpdate,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: groupDelete } = useMutation(
    [endpoints.refcode.lecture.group.delete],
    fetcher.refcode.postLectureGroupDelete,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, groupList, refetch, groupInsert, groupUpdate, groupDelete };
};

export default useLectureGroup;
